import React from 'react';
import { useTranslation } from 'react-i18next';
import { CloseButton, LiliButton } from '@lili/lili-frontend-common';
import { UserMessage } from '../../../DesignSystem/LiliUserMessage/UserMessage';
import { ReactComponent as IconVSuccessSign } from '../../../assets/icons/svg/colored-icons/ic-colored-success.svg';
import { ReactComponent as IconAlert } from '../../../assets/icons/svg/stamp-icons/ic-stamp-alert.svg';

interface IGustoModalProps {
  onClose: () => void;
  modalType: string;
  title: string;
  subtitle: string;
}

export const MODAL_TYPES = {
  SUCCESS_CONNECT: 'SUCCESS_CONNECT',
  SUCCESS_DISCONNECT: 'SUCCESS_DISCONNECT',
  COULD_NOT_CONNECT: 'COULD_NOT_CONNECT',
  NONE: 'NONE',
};

const getModalTitleByModalType = (modalType: string): string => {
  if (modalType === MODAL_TYPES.SUCCESS_CONNECT) return 'GUSTO.SUCCESS.CONNECT.TITLE';
  if (modalType === MODAL_TYPES.SUCCESS_DISCONNECT) return 'GUSTO.SUCCESS.DISCONNECT.TITLE';
  if (modalType === MODAL_TYPES.COULD_NOT_CONNECT) return 'GUSTO.ERRORS.COULD_NOT_CONNECT.TITLE';
  return '';
};
const getModalSubtitleByModalType = (modalType: string): string => {
  if (modalType === MODAL_TYPES.SUCCESS_CONNECT) return 'GUSTO.SUCCESS.CONNECT.SUBTITLE';
  if (modalType === MODAL_TYPES.SUCCESS_DISCONNECT) return '';
  if (modalType === MODAL_TYPES.COULD_NOT_CONNECT) return 'GUSTO.ERRORS.COULD_NOT_CONNECT.SUBTITLE';
  return '';
};
const GustoModal = ({ onClose, modalType, title, subtitle }: IGustoModalProps) => {
  const { t } = useTranslation();
  const ModalIcon =
    modalType === MODAL_TYPES.SUCCESS_CONNECT || modalType === MODAL_TYPES.SUCCESS_DISCONNECT
      ? IconVSuccessSign
      : IconAlert;
  const modalTitle = title || t(getModalTitleByModalType(modalType) as any);
  const modalSubtitle = subtitle || t(getModalSubtitleByModalType(modalType) as any);
  return (
    <UserMessage
      onClick={onClose}
      id='Gusto-Modal'
      mainWrapperOverrideClassName='bg-bw07 flex justify-center fixed inset-0 h-screen w-full bg-opacity-70 z-50'
    >
      <CloseButton
        id='gusto-modal-close-button'
        className='absolute top-3 right-3 cursor-pointer z-10 rounded-full fill-bw07 hover:bg-bw02'
        onClick={onClose}
      />
      <div className='bg-bw00 w-[343px] rounded-[12px] pt-[34px] px-[24px] pb-[24px] flex flex-col items-center'>
        {ModalIcon && (
          <div className='mb-[20px]'>
            <ModalIcon className='w-[76px] h-[76px]' />
          </div>
        )}
        {modalTitle && (
          <div
            className={`font-metricR text-[18px] text-bw08 leading-6 tracking-[-0.202px] text-center ${!modalSubtitle ? 'mb-[28px]' : ''}`}
          >
            {modalTitle}
          </div>
        )}
        {modalSubtitle && (
          <div className='font-metricR text-md text-bw07 leading-5 text-center mt-[8px] mb-[28px]'>{modalSubtitle}</div>
        )}
        <LiliButton onClick={onClose} className='w-full h-[54px]' id='' title={t('GUSTO.GOT_IT_BUTTON')} />
      </div>
    </UserMessage>
  );
};
export default GustoModal;
